export enum WeightUnit {
  G = 'g',
  KG = 'kg',
  LB = 'lb',
  OZ = 'oz',
}

/* eslint-disable perfectionist/sort-objects */
export const weightUnitMap: Record<string, WeightUnit> = {
  [WeightUnit.G]: WeightUnit.G,
  [WeightUnit.KG]: WeightUnit.KG,
  [WeightUnit.OZ]: WeightUnit.OZ,
  [WeightUnit.LB]: WeightUnit.LB,
};
/* eslint-enable perfectionist/sort-objects */

type SafeWeightUnitMap<K extends keyof typeof WeightUnit = keyof typeof WeightUnit> = Record<
  Lowercase<K>,
  (typeof WeightUnit)[K]
>;

// There's really no reason that this can't replace `weightUnitMap`. I'm just not prepared to check usages of the existing one.
// If you're trying to choose between the two, you should use this one. Your IDE will know what keys it has and help you with autocompletion.
/* eslint-disable perfectionist/sort-objects */
export const safeWeightUnitMap: SafeWeightUnitMap = {
  g: WeightUnit.G,
  kg: WeightUnit.KG,
  oz: WeightUnit.OZ,
  lb: WeightUnit.LB,
};
/* eslint-enable perfectionist/sort-objects */

/**
 * Maps to the api_unit table
 */
export enum ApiUnit {
  _Centimetre = 1,
  _Foot = 3,
  _Inch = 2,
  _Kilometre = 11,
  _Metre = 8,
  _Mile = 12,
  _Millimetre = 9,
  _Yard = 10,
  Gram = 4,
  Kilogram = 7,
  Ounce = 5,
  Pound = 6,
}

/* eslint-disable perfectionist/sort-objects */
export const apiUnitMap: Record<string, ApiUnitWeight> = {
  [WeightUnit.G]: ApiUnit.Gram,
  [WeightUnit.KG]: ApiUnit.Kilogram,
  [WeightUnit.OZ]: ApiUnit.Ounce,
  [WeightUnit.LB]: ApiUnit.Pound,
};
/* eslint-enable perfectionist/sort-objects */

export type ApiUnitWeight = ApiUnit.Gram | ApiUnit.Kilogram | ApiUnit.Ounce | ApiUnit.Pound;

export const apiUnitWeightMap: Record<ApiUnitWeight, WeightUnit> = {
  [ApiUnit.Gram]: WeightUnit.G,
  [ApiUnit.Kilogram]: WeightUnit.KG,
  [ApiUnit.Ounce]: WeightUnit.OZ,
  [ApiUnit.Pound]: WeightUnit.LB,
};
